import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/WebDevelopment.css';

const services = [
  {
    id: 1,
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="8" width="40" height="28" rx="3" stroke="currentColor" strokeWidth="2.2" />
        <path d="M16 44h16M24 36v8" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M4 30h40" stroke="currentColor" strokeWidth="2.2" />
      </svg>
    ),
    title: "Tailored WordPress Solutions",
    desc: "Crafted to address unique business challenges, our WordPress development services are designed to exceed expectations, delivering bespoke solutions that resonate with your brand.",
  },
  {
    id: 2,
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="18" stroke="currentColor" strokeWidth="2.2" />
        <path d="M24 6c0 0-6 8-6 18s6 18 6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M24 6c0 0 6 8 6 18s-6 18-6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M6 24h36M8 16h32M8 32h32" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    ),
    title: "WordPress Revamp & Customization",
    desc: "Transform your digital presence seamlessly with our WordPress revamp and customization services, allowing for swift modifications, achieving quick roll-outs and cost-effectiveness.",
  },
  {
    id: 3,
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 4L6 14v10c0 9.4 7.7 18.2 18 20 10.3-1.8 18-10.6 18-20V14L24 4z" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
        <path d="M16 24l6 6 10-12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "WordPress Maintenance & Security",
    desc: "Ensure the ongoing performance, security, and functionality of your WordPress site with our comprehensive maintenance services. From bug fixes to security patches, we've got you covered.",
  },
  {
    id: 4,
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="8" width="26" height="20" rx="2" stroke="currentColor" strokeWidth="2.2" />
        <rect x="18" y="22" width="26" height="18" rx="2" stroke="currentColor" strokeWidth="2.2" />
        <path d="M10 36h4M26 12h10" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    ),
    title: "Bespoke WordPress Application Development",
    desc: "As your dedicated WordPress development company, we specialize in building custom applications from the ground up, offering seamless migrations, backend enhancements, and optimized frontend functionalities.",
  },
  {
    id: 5,
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="16" r="8" stroke="currentColor" strokeWidth="2.2" />
        <path d="M8 40c0-8.8 7.2-16 16-16s16 7.2 16 16" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M32 20l4 4-4 4M36 24h-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "WordPress Support & Consultation",
    desc: "Get expert guidance and round-the-clock support for your WordPress platform. Our team of specialists is always ready to assist, ensuring your website runs flawlessly at all times.",
  },
  {
    id: 6,
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 36L6 42h36l-4-6" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
        <rect x="14" y="8" width="20" height="28" rx="2" stroke="currentColor" strokeWidth="2.2" />
        <path d="M19 14h10M19 20h10M19 26h6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    ),
    title: "WordPress SEO & Performance Optimization",
    desc: "Boost your search rankings and site speed with our WordPress SEO and performance optimization services. We fine-tune every element to deliver lightning-fast load times and maximum visibility.",
  },
];

const WebDevelopment = () => {
  const navigate = useNavigate();

  const goToContact = () => {
    navigate('/contact');
  };

  return (
    <>
      {/* FIRST SECTION */}
      <section className="wd-section">
        <div className="wd-hero">
          <span className="wd-hero-tag">WordPress Development</span>
          <h1 className="wd-hero-heading">
            Elevating Digital Frontiers with our{" "}
            <span className="wd-hero-accent">Expert WordPress</span>{" "}
            Development Services
          </h1>
          <p className="wd-hero-sub">
            Elevate your digital presence with our specialized WordPress development
            services, where we merge creativity and functionality.
          </p>
        </div>

        <div className="wd-grid">
          {services.map((s) => (
            <div className="wd-card" key={s.id}>
              <div className="wd-card-icon">{s.icon}</div>
              <h3 className="wd-card-title">{s.title}</h3>
              <p className="wd-card-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* SECOND SECTION (SHOPIFY) */}
      <section className="shopify-section">
        <div className="shopify-container">
          <div className="shopify-left">
            <h1>Shopify</h1>
            <h2>Development Company</h2>

            <p>
              With the help of Emizentech, the Best Shopify Development Company,
              you can maximize your company’s potential.
            </p>

            <button type="button" className="shopify-btn" onClick={goToContact}>
              Request A Proposal →
            </button>
          </div>

          <div className="shopify-right">
            <div className="mockup">
              <img src="imagee.webp" alt="shopify mockup" />
            </div>

            <div className="features">
              <span>Headless Stores</span>
              <span>POS & ERP Integration</span>
              <span>On Time Delivery</span>
              <span>Custom Apps</span>
            </div>
          </div>
        </div>
      </section>

      <section className="tech-section">
  <div className="tech-container">

    {/* HEADING */}
    <h2 className="tech-heading">
      Custom Web Development Technologies
    </h2>

    <p className="tech-subheading">
      We use modern tools and technologies to build fast, scalable and powerful
      web applications for your business growth.
    </p>

    {/* BOXES */}
    <div className="tech-grid">

      {/* FRONTEND */}
      <div className="tech-box">
        <h3>Frontend Programming</h3>

        <div className="tech-icons">
          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg" alt="Angular logo" />
          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React logo" />
          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-plain.svg" alt="WordPress logo" />
          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" alt="HTML5 logo" />
          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" alt="CSS3 logo" />
          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" alt="JavaScript logo" />
          <img src="https://upload.wikimedia.org/wikipedia/commons/7/76/Wix.com_website_logo.svg" alt="Wix logo" />
        </div>
      </div>

      {/* BACKEND */}
      <div className="tech-box">
        <h3>Backend Programming</h3>

        <div className="tech-icons">
          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" alt="Node.js logo" />
          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg" alt="PHP logo" />
        </div>
      </div>

    </div>
  </div>
</section>


<section className="uiux-dark-section">

  <div className="uiux-container">

    {/* LEFT CONTENT */}
    <div className="uiux-left">
      <h2 className="uiux-title">
        Mobile App User <br />
        Interface & Experience Design
      </h2>

      <p className="uiux-desc">
        With our defined approach and step by step process, we deliver beyond 
        what's expected. We craft brilliance together and build experiences 
        that are modern, scalable and user-focused.
      </p>

      <button type="button" className="uiux-btn" onClick={goToContact}>
        Book a free consultation →
      </button>
    </div>

    {/* RIGHT IMAGE */}
    <div className="uiux-right">
      <img src="/OIP.webp" alt="uiux preview" />
    </div>

  </div>

  {/* SECOND PART */}
  <div className="ux-process">

    <h2 className="ux-heading">
      Keep your users at the center of your design process
    </h2>

    <p className="ux-sub">
      We combine experience, research and strategy to build powerful UX systems.
    </p>

    <div className="ux-cards">

      <div className="ux-card">
        <h3>Discover</h3>
        <ul>
          <li>User Research</li>
          <li>User Surveys</li>
          <li>User Personas</li>
          <li>User Stories</li>
        </ul>
      </div>

      <div className="ux-card">
        <h3>Define</h3>
        <ul>
          <li>Information Architecture</li>
          <li>Site Maps</li>
          <li>Empathy Mapping</li>
          <li>User Journey Map</li>
        </ul>
      </div>

      <div className="ux-card">
        <h3>Deliver</h3>
        <ul>
          <li>Paper Prototyping</li>
          <li>High Fidelity Mockups</li>
          <li>User Personas</li>
        </ul>
      </div>

    </div>

  </div>

</section>


    </>
  );
};

export default WebDevelopment;